import {z as r} from 'zod';

import {ReviewSentimentEnum} from '../reviews-type';

export enum ReviewPresenceActionEnum {
    Reply = 'reply',
    EditReply = 'edit_reply',
    ResponsibleUser = 'responsible_user',
    BulkSelect = 'bulk_select',
    Abuse = 'abuse',
    Status = 'status',
}

export enum ReviewPresenceEventEnum {
    Lock = 'lock',
    Unlock = 'unlock',
    Heartbeat = 'heartbeat',
    Update = 'update',
}

export enum ReviewPresenceBlockedActionEnum {
    Status = 'status',
    Reply = 'reply',
    Abuse = 'abuse',
    EditReply = 'edit_reply',
    DeleteReply = 'delete_reply',
    ResponsibleUser = 'responsible_user',
    RemoveResponsible = 'remove_responsible',
    BulkSelect = 'bulk_select',
}

const reviewPresenceLockEventSchema = r.union([
    r.literal(ReviewPresenceEventEnum.Lock),
    r.literal(ReviewPresenceEventEnum.Unlock),
    r.literal(ReviewPresenceEventEnum.Heartbeat),
]);

export const reviewPresenceLockPublicationSchema = r.object({
    reviewId: r.number(),
    brandId: r.number(),
    userId: r.number(),
    sessionId: r.string(),
    action: r.nativeEnum(ReviewPresenceActionEnum),
    event: reviewPresenceLockEventSchema,
    timestamp: r.number(),
});

export type ReviewPresenceLockPublicationType = r.infer<typeof reviewPresenceLockPublicationSchema>;

export const reviewRealtimeUpdateChangesSchema = r
    .object({
        processStatus: r.string().optional(),
        tags: r.array(r.record(r.unknown())).nullable().optional(),
        responsibleUser: r.record(r.unknown()).nullable().optional(),
        sentiment: r
            .union([
                r.literal(ReviewSentimentEnum.positive),
                r.literal(ReviewSentimentEnum.neutral),
                r.literal(ReviewSentimentEnum.negative),
            ])
            .nullable()
            .optional(),
        isHidden: r.boolean().optional(),
        abuseLastDate: r.string().nullable().optional(),
        children: r.array(r.record(r.unknown())).optional(),
        notes: r.array(r.record(r.unknown())).optional(),
        deletedAt: r.string().nullable().optional(),
        moderated: r.boolean().optional(),
        lastChangesDate: r.string().nullable().optional(),
        hasAccountError: r.boolean().optional(),
        isSynchronizationAccount: r.boolean().optional(),
    })
    .partial()
    .refine((changes) => Object.keys(changes).length > 0);

export type ReviewRealtimeUpdateChangesType = r.infer<typeof reviewRealtimeUpdateChangesSchema>;

export const reviewPresenceUpdatePublicationSchema = r.object({
    reviewId: r.number(),
    brandId: r.number(),
    userId: r.number(),
    sessionId: r.string(),
    event: r.literal(ReviewPresenceEventEnum.Update),
    timestamp: r.number(),
    changes: reviewRealtimeUpdateChangesSchema,
});

export type ReviewPresenceUpdatePublicationType = r.infer<typeof reviewPresenceUpdatePublicationSchema>;

export type ReviewLockType = {
    reviewId: number;
    brandId: number;
    userId: number;
    sessionId: string;
    action: ReviewPresenceActionEnum;
    lastSeenAt: number;
};

export type ReviewRealtimeLockMapType = Record<number, ReviewLockType>;

export type ReviewPresenceActivityOptionsType = {
    reviewId: number;
    brandId: number;
    action: ReviewPresenceActionEnum;
};

export type PublishReviewUpdateType = (
    reviewId: number,
    brandId: number,
    changes: ReviewRealtimeUpdateChangesType
) => void;
